//Scroll to top of the page
$(document).ready(function($) {
  $('.accordion').find('.accordion-toggle').click(function(){
    //Expand or collapse this panel
    $(this).parent().siblings('.kono-type-list-view__teaser').find('.kono-type-list-view__description').find('.kono-type-list-view__description--wrap').toggleClass('accordian-active');
    $(this).next().slideToggle(250);
    $(this).toggleClass('show');
  });
});



// WEBPACK FOOTER //
// ./src/js/accordion.js